/* @flow weak */
import cx from 'classnames';
import Money from 'payments/components/Money.jsx';
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/Counter.scss';

class Counter extends React.Component {
  static propTypes = {
    label: React.PropTypes.node.isRequired,
    labelSize: React.PropTypes.oneOf([
      'xxxxsmall',
      'xxxsmall',
      'xxsmall',
      'xsmall',
      'small',
      'medium',
      'large',
      'xlarge',
      'xxlarge',
      'xxxlarge',
      'xxxxlarge',
    ]),
    labelWeight: React.PropTypes.oneOf([
      'bold',
      'semibold',
      'normal',
      'light',
    ]),
    value: React.PropTypes.node.isRequired,
    valueSize: React.PropTypes.oneOf([
      'xxxxsmall',
      'xxxsmall',
      'xxsmall',
      'xsmall',
      'small',
      'medium',
      'large',
      'xlarge',
      'xxlarge',
      'xxxlarge',
      'xxxxlarge',
    ]),
    valueWeight: React.PropTypes.oneOf([
      'bold',
      'semibold',
      'normal',
      'light',
    ]),
  };

  static defaultProps = {
    labelSize: 'xsmall',
    labelWeight: 'normal',
    valueSize: 'xxxxlarge',
    valueWeight: 'normal',
  };

  render() {
    const { label } = this.props;
    const value = this.props.value || 0;

    return (
      <div className={cx('Counter', this.props.className)}>
        <Text
          className="Counter-text"
          size={this.props.valueSize}
          weight={this.props.valueWeight}>
          {value}
        </Text>
        <Text
          className="Counter-text"
          size={this.props.labelSize}
          weight={this.props.labelWeight}>
          {label}
        </Text>
      </div>
    );
  }
}

export const MoneyCounter = ({ cents, ...rest }) =>
  <Counter value={<Money cents={cents} />} {...rest} />;

MoneyCounter.propTypes = {
  cents: React.PropTypes.number.isRequired,
};

export default Counter;



// WEBPACK FOOTER //
// ./src/components/Counter.jsx